import React from "react";
import DriverDashboard from "./DriverDashboard";

// Driver home tab mirrors the driver dashboard on web.
export default function DriverHome() {
  return <DriverDashboard />;
}
